import { useEffect } from 'react';

export const useInterval = (callback: () => void, delay = 1000) => {
    useEffect(() => {
        const intervalId = setInterval(callback, delay);
        return () => clearInterval(intervalId);
    }, [callback, delay]);
};
